// The phone menu: a slide-in dialog opened by the burger button.
import { createDialog } from './dialog.js';
export function mountMenu(doc = document) {
  const el = doc.getElementById('menu'); if (!el) return null;
  const trigger = doc.querySelector('[data-menu-open]');
  const dlg = createDialog(el, { veil: doc.querySelector('.menu-veil'), trigger });
  trigger?.addEventListener('click', dlg.open);
  el.addEventListener('click', e => {
    if (e.target.closest('[data-menu-close]')) return dlg.close();
    // links to a section of this same page: close first so the page can scroll to it
    if (e.target.closest('a[href]')) dlg.close();
  });
  return dlg;
}
